<template>
    <div class="ma-4 app">
      <div class="text-h4 mb-2">Cadastro de integrações</div>
      <v-tabs v-model="tabs" background-color="background">
        <v-tab v-for="n in tipos" :key="n">
          {{ tipo[n - 1] }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <AbaSigma />
          <AbaIa />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </template>
  
  <script>
  import AbaSigma from '../_components/AbaSigma'
  import AbaIa from '../_components/AbaIa.vue'
  
  export default {
    name: 'CadastroAgendamento',
    components: { AbaSigma , AbaIa},
    data: () => ({
      tipos: 2,
      tab: null,
      tabs: 2,
      tipo: ['Sigma', 'IA'],
    }),
  }
  </script>
  
  <style scoped>
  .app {
    background-color: var(--v-background-base);
  }
  </style>
  